import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdminState {
    isAdminLoggedIn: boolean;
}

const initialState: AdminState = {
    isAdminLoggedIn: false,
};

const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setAdminLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isAdminLoggedIn = action.payload;
        },
    },
});

export const { setAdminLoggedIn } = adminSlice.actions;
export const adminReducer = adminSlice.reducer;